import { createApi } from '@reduxjs/toolkit/query/react';

import { TAGS_CHUNK, POST, GET } from '@app/constants';
import { customBaseQuery } from '@app/services/rtkQuery/baseQuery';
import type { NApiTags } from '@app/services/rtkQuery/Tags/types';
import type { NAuth, NTags } from '@app/types';

export const tagsApi = createApi({
  reducerPath: 'tagsApi',
  baseQuery: ({ url, ...props }) =>
    customBaseQuery({ url: `${TAGS_CHUNK}/${url}`, ...props }),
  tagTypes: ['ActionHistory'],
  endpoints: ({ mutation, query }) => ({
    SetClientsTagsBySearchId: mutation<
      void,
      NApiTags.SetClientsTagsBySearchIdRequest
    >({
      query: ({ ActiveBranchId, ...data }) => ({
        url: 'SetClientsTagsBySearchId',
        method: POST,
        params: { ActiveBranchId },
        data,
      }),
    }),
    GetTags: query<
      NTags.Tag[],
      {
        ActiveBranchId: NAuth.UserPrint['activeBranchId'];
        onlyClient: boolean;
      }
    >({
      query: (params) => ({
        url: 'GetTags',
        method: GET,
        params,
      }),
    }),
    UpdateClientTags: mutation<void, NApiTags.UpdateClientTagsRequest>({
      query: ({ data, ...params }) => ({
        url: 'UpdateClientTags',
        method: POST,
        params,
        data,
      }),
    }),
    GetAllTags: query<
      NTags.Tag[],
      {
        ActiveBranchId: NAuth.UserPrint['activeBranchId'];
      }
    >({
      query: (params) => ({
        url: 'GetAllTags',
        method: GET,
        params,
      }),
    }),
    GetListTags: query<
      NTags.Tag[],
      { ActiveBranchId: NAuth.UserPrint['activeBranchId'] }
    >({
      query: (params) => ({
        url: 'GetAllTags',
        method: GET,
        params,
      }),
    }),
  }),
});

export const {
  useSetClientsTagsBySearchIdMutation,
  useGetTagsQuery,
  useLazyGetTagsQuery,
  useUpdateClientTagsMutation,
  useLazyGetAllTagsQuery,
  useLazyGetListTagsQuery,
} = tagsApi;
